import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Factuur, FactuurInfo, FactuurObject } from '../model/factuur';
import { ObjectRelatieGegevens } from '../model/relatie';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root'
})
export class FactuurService {

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  private objecten: Array<FactuurObject> = null;

  baseURl: string = "http://localhost:3000/dev/";


  constructor(private http: HttpClient,private common: CommonService) {
    this.baseURl = environment.url;
   }




  getObjecten(all : boolean = false):  Observable<Array<FactuurObject>> {
    const me = this;
    if (this.objecten != null ) {
        return new Observable<any>( (observer) => {
            observer.next(me.objecten);
            observer.complete();
        } );
    }
    const params = new HttpParams()
    .set('all', all ?  'true' :  'false')
    return new Observable<any>( (observer) => {
      this.http.get(this.baseURl +  "factuur/objecten",{params}).pipe(
          tap(_ => this.log('fetched factuur/objecten')),
          tap(e => { this.common.checkAndReportErrors(e)}),
          catchError(this.handleError<any>('getList', []))
          ).subscribe(data => {
            me.objecten = data;
            observer.next(me.objecten);
            observer.complete();
        });
      });
  }

  getObjectenFilter(filters : any):  Observable<Array<FactuurObject>> {
    const me = this;
    let params = new HttpParams();
    for (const key in filters) {
      params = params.set(key,filters[key])
    }
    return new Observable<any>( (observer) => {
      this.http.get(this.baseURl +  "factuur/objecten",{params}).pipe(
          tap(_ => this.log('fetched factuur/objecten')),
          tap(e => { this.common.checkAndReportErrors(e)}),
          catchError(this.handleError<any>('getList', []))
          ).subscribe(data => {
            me.objecten = data;
            observer.next(me.objecten);
            observer.complete();
        });
      });
  }

  getFactuur(id : number) : Observable<Factuur> {
    return this.http.get(this.baseURl +  "factuur/" + id).pipe(
      tap(_ => this.log('fetched factuurobject')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('getFactuur', []))
    );
  }

  getFactuurNr(factuurNr : number) : Observable<Factuur> {
    return this.http.get(this.baseURl +  "factuur/nr/" + factuurNr).pipe(
      tap(_ => this.log('fetched factuurobject')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('getFactuur', []))
    );
  }

  getRelatieGegevens(objectid: number) : Observable<ObjectRelatieGegevens> {
    return this.http.get(this.baseURl +  "objecten/" + objectid + "/relatiegegevens").pipe(
      tap(_ => this.log('fetched factuurobject')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('getFactuur', []))
    );
  }

  saveFactuur(id: Number, factuur: Factuur) {
    return this.http.put(this.baseURl +  "factuur/" + id ,factuur, this.httpOptions).pipe(
      tap(_ => this.log('factuur saved')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('saveFactuur', []))
    );
  }

  postFactuur(factuur: Factuur) {
    return this.http.post(this.baseURl +  "factuur" ,factuur, this.httpOptions).pipe(
      tap(_ => this.log('factuur added')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('postFactuur', []))
    );
  }


  getFactuurInfo(factuurid : number) : Observable<Array<FactuurInfo>> {
    return this.http.get(this.baseURl +  "factuur/FactuurInfo/" + factuurid).pipe(
      tap(_ => this.log('fetched getFactuurInkoop')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('getFactuurInkoop', []))
    );
  }

  getFactuurInfoCorr(factuurid : number) : Observable<Array<FactuurInfo>> {
    return this.http.get(this.baseURl +  "factuur/FactuurInfoCorr/" + factuurid).pipe(
      tap(_ => this.log('fetched getFactuurInkoop')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('getFactuurInkoop', []))
    );
  }



  saveFactuurInfo(id: Number, object: FactuurInfo) {
    return this.http.put(this.baseURl +  "factuur/FactuurInkoop/" + id ,object, this.httpOptions).pipe(
      tap(_ => this.log('object saved')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('saveObject', []))
    );
  }


  deleteFactuurInkoop(id: number) {
    return this.http.delete(this.baseURl +  "factuur/FactuurInkoop/" + id ,this.httpOptions).pipe(
      tap(_ => this.log('object saved')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('saveObject', []))
    );

  }

  postRapport(factuurid: number,adresid : number) {
    return this.http.post(this.baseURl +  "factuur/rapport/", {factuurid:factuurid,adresid:adresid},this.httpOptions).pipe(
      tap(_ => this.log('postRapport')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('postRapport', []))
    );
  }


  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }


  private log(message: string) {
    console.log(`FactuurService: ${message}`);
  }




}
